var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('component',_vm._b({class:[_vm.isActive ? (_vm.componentProps.blok.active_style ? _vm.componentProps.blok.active_style : '') : ''],on:{"click":_vm.handleClick}},'component',_vm.componentProps ? _vm.componentProps : { is: 'div' },false))}
var staticRenderFns = []

export { render, staticRenderFns }